import React, { Component } from 'react';
import { Grid, Row, Col, Badge } from 'react-bootstrap/lib'
import Api from './Api';

const FETCH_URL = "api/footer/data"

const FOOTER_MEMBER = "LEDEN"
const FOOTER_ASPIRANT = "KANDIDAATLEDEN"
const FOOTER_RC = "REGISTERCONSTRUCTEURS"
const FOOTER_RTa = "REGISTERTOETSERA"
const FOOTER_RTb = "REGISTERTOETSERB"
const FOOTER_RO = "REGISTERONTWERPERS"

class FooterCounters extends Component {
	constructor(props) {
		super(props)
		this.handleFooter = this.handleFooter.bind(this)
		this.state = {
			[FOOTER_MEMBER]: "",
			[FOOTER_ASPIRANT]: "",
			[FOOTER_RC]: "",
			[FOOTER_RTa]: "",
			[FOOTER_RTb]: "",
			[FOOTER_RO]: ""
		}
	}

	componentDidMount() {
		Api.GetApi(FETCH_URL).then(response => {
			if (response !== undefined)
				response.data.forEach(e => {
					this.setState({ [e.code]: e.value })
				});

		})
	}

	handleFooter(event) {

	}


	render() {
		return (
			<div className="FooterCounters">
				<Grid>
					<Row>
						<Col className="" md={3} sm={6}>
							<div className="">
								<p>
									<Badge>{this.state[FOOTER_MEMBER]}</Badge> Leden
                  </p>
							</div>
						</Col>
						<Col className="" md={3} sm={6}>
							<div className="">
								<p>
									<Badge>{this.state[FOOTER_ASPIRANT]}</Badge> Kandidaatleden
                  </p>
							</div>
						</Col>
						<Col className="" md={3} sm={6}>
							<div className="">
								<p>
									<Badge>{this.state[FOOTER_RC]}</Badge> Registerconstructeurs
                  </p>
								<p>
									<Badge>{this.state[FOOTER_RO]}</Badge> Registerontwerpers
                  </p>
							</div>
						</Col>
						<Col className="" md={3} sm={6}>
							<div className="">
								<p>
									<Badge>{this.state[FOOTER_RTa]}</Badge> Registertoetser A
                  </p>
								<p>
									<Badge>{this.state[FOOTER_RTb]}</Badge> Registertoetser B
                  </p>
							</div>
						</Col>
					</Row>
				</Grid>
			</div>
		);
	}
}

export default FooterCounters;


// WEBPACK FOOTER //
// ./src/components/Global/Modules/FooterCounters.js